import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Radio } from "lucide-react";

const ago = (m) => (m < 60 ? `${m}m` : `${Math.floor(m / 60)}h ${m % 60}m`);
const initials = (n) => (n || "?").split(" ").slice(0, 2).map((p) => p[0]).join("").toUpperCase();

export default function OnShiftBoard() {
  const [data, setData] = useState({ count: 0, on_shift: [] });
  useEffect(() => {
    const load = () => api.get("/on-shift").then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm px-4 py-2.5 mb-3 flex items-center gap-x-3 gap-y-2 flex-wrap" data-testid="on-shift-board">
      <div className="flex items-center gap-2 shrink-0">
        <span className="relative flex h-2.5 w-2.5">
          <span className={`absolute inline-flex h-full w-full rounded-full ${data.count ? "bg-emerald-400 animate-ping" : "bg-slate-300"} opacity-75`} />
          <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${data.count ? "bg-emerald-500" : "bg-slate-400"}`} />
        </span>
        <h2 className="text-sm font-bold text-slate-900 flex items-center gap-1.5"><Radio className="w-4 h-4 text-emerald-500" /> On shift now</h2>
        <span className="text-xs text-slate-400">({data.count})</span>
      </div>
      {data.count === 0 ? (
        <span className="text-sm text-slate-400">Nobody is clocked in right now.</span>
      ) : (
        <div className="flex flex-wrap gap-2">
          {data.on_shift.map((p) => (
            <div key={p.user_id} className="flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 pl-1 pr-3 py-1" data-testid={`on-shift-${p.user_id}`}>
              <span className="w-6 h-6 rounded-full bg-emerald-600 text-white text-[10px] font-bold flex items-center justify-center">{initials(p.name)}</span>
              <span className="text-xs font-medium text-emerald-900">{p.name}</span>
              <span className="text-[10px] text-emerald-600">{ago(p.minutes)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
